import { useEffect, useState } from "react";
import { products as defaultProducts, serviceDetails as defaultServices } from "../data/jalRoData";

const withFallback = (items, fallback) => {
  if (!Array.isArray(items) || items.length === 0) return fallback;
  return items;
};

const useJsonData = (path, fallback) => {
  const [items, setItems] = useState(fallback);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;

    fetch(`${path}?v=${Date.now()}`)
      .then((response) => {
        if (!response.ok) throw new Error("JSON not found");
        return response.json();
      })
      .then((data) => {
        if (!cancelled) setItems(withFallback(data, fallback));
      })
      .catch(() => {
        if (!cancelled) setItems(fallback);
      })
      .finally(() => {
        if (!cancelled) setLoaded(true);
      });

    return () => {
      cancelled = true;
    };
  }, [path, fallback]);

  return { items, loaded };
};

export const useProducts = () => useJsonData("/data/products.json", defaultProducts);

export const useServices = () => useJsonData("/data/services.json", defaultServices);
